import { Component, Input, OnChanges, SimpleChanges, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { PaymentsService } from '../../data-access/payments.service';
import { Router } from '@angular/router';
import { CartStateService } from '../../data-access/cart-state.service';

@Component({
  standalone: true,
  imports: [
    MatIcon,
    MatButtonModule
  ],
  providers: [
    PaymentsService
  ],
  selector: 'equine-ui-nx-toolbar-cart-button',
  templateUrl: './toolbar-cart-button.component.html',
  styleUrls: ['./toolbar-cart-button.component.scss']
})
export class ToolbarCartButtonComponent implements OnChanges {
  private cartStateService = inject(CartStateService);
  private paymentsService = inject(PaymentsService);
  private router = inject(Router);

  @Input() memberId!: string | null;

  count = this.cartStateService.totalItems;
  emptyCart = this.cartStateService.emptyCart;

  ngOnChanges(): void {
    if (this.memberId) {
      this.paymentsService.getCartSummary(undefined, this.memberId).subscribe();
    }
  }

  goToCart() {
    this.router.navigate(['payments', 'payment-summary']);
  }

}
